import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import Documentos from "./sections/Documentos";
import AboutMva from "./sections/AboutMva";
import AuditProcess from "./sections/AuditProcess";
import Dhl from "./sections/Dhl";
import ConnectWithOurLeaders from "./sections/ConnectWithOurLeaders";
import Faqs from "./sections/Faqs";
import Aviso from "./sections/Aviso";
import CompanyStrengthsAndPricing from "./sections/CompanyStrengthsAndPricing";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBanner />
      <Documentos />
      <AboutMva />
      <AuditProcess />
      <Dhl />
      <ConnectWithOurLeaders />
      <Faqs />
      <Aviso />
      <CompanyStrengthsAndPricing />
      <Footer />
    </div>;
}